import {
  Pencil2Icon,
  CalendarIcon,
  BarChartIcon,
  DesktopIcon,
} from "@radix-ui/react-icons";

export const MASTER_ACCESS_DASHBOARD_PATH = "/master-access-dashboard";

export const NAV_ITEMS = [
  { to: "/", icon: DesktopIcon, label: "Dashboard" },
  { to: "/trends", icon: BarChartIcon, label: "Trends" },
  { to: "/chargers", icon: CalendarIcon, label: "Chargers" },
  { to: "/fleet", icon: Pencil2Icon, label: "Fleet" },
];
